module.exports = __webpack_public_path__ + "img/fc.13f24689.png";